import correctEndpointUrl from "./firebaseEndpoint";
import sanitizeObject from "../methods/utils/sanitizeObject";

export default (endpoint, payload, method = "POST") => fetch(`${correctEndpointUrl}/${endpoint}`, {
  method,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${window.sessionStorage.getItem("token")}`,
  },
  body: JSON.stringify(sanitizeObject(payload)),
});
